import { MainWrapper } from '@app/components/layout/main-wrapper/MainWrapper';
import { AppSidenav } from '@app/components/layout/sidenav/AppSidenav';
import { GlobalLivePlayer } from '@app/features/global-live-player/GlobalLivePlayer';
import { ModulesRoutes } from '@app/modules/ModulesRoutes';
import { getBrowserTimezone } from '@mi-front/core';
import { memo } from 'react';
import { useUserLocaleCheck } from '../auth/profile/hooks/useUserLocaleCheck';
import { TimezoneCtxProvider } from '../context/timezone.context';
import { useTestError } from '../hooks/useTestError';
import { IntegrationsTracking } from '../integrations/IntegrationsTracking';
import { UrlMediaPlayer } from '../media-player/UrlMediaPlayer';
import { UrlMediaPlayerProvider } from '../media-player/useUrlMediaPlayer';
import { VersionChecker } from '../version-check/VersionChecker';
import { AppReadyTracking } from './AppReadyTracking';

export const App = memo(() => {
  useTestError();
  useUserLocaleCheck();

  return (
    <IntegrationsTracking>
      <VersionChecker />
      <UrlMediaPlayerProvider>
        <TimezoneCtxProvider
          value={{
            timezone: getBrowserTimezone(),
          }}
        >
          <AppReadyTracking />
          <MainWrapper sidenav={<AppSidenav />} content={<ModulesRoutes />} />
        </TimezoneCtxProvider>
        <UrlMediaPlayer />
        <GlobalLivePlayer />
      </UrlMediaPlayerProvider>
    </IntegrationsTracking>
  );
});
